import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Grid, Row, Col, Form, FormGroup, FormControl, Button, InputGroup } from 'react-bootstrap';
import './MediaSearch.css';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { getSearchedMedia } from '../../actions';

class MediaSearch extends Component {

    constructor(props) {
        super(props);
        this.state = { value: '' };

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }



    handleSubmit(event) {
        const { getSearchedMedia } = this.props;
        event.preventDefault();
        getSearchedMedia(this.state.value);
    }

    handleChange(event) {
        this.setState({ value: event.target.value });
    }

    render() {
        const { mediaSearchResult } = this.props;

        var foundMedia = [];

        if (mediaSearchResult.length) {
            foundMedia = mediaSearchResult;
        }

        this.options = {
            defaultSortName: 'MediaName',
            defaultSortOrder: 'asc'
        };

        return (
            <div className="media-search-main">
                <Grid fluid>
                    <Row>
                        <Col xs={6} md={6}>
                            <div className="activity-skills-header">
                                <h3>Media Search</h3>
                            </div>
                        </Col>
                        <Col xs={6} md={6}>
                            <Form inline onSubmit={this.handleSubmit} className="pull-right search-form">
                                <FormGroup controlId="mediaSearchValue">
                                    <InputGroup>
                                        <FormControl
                                            type="text"
                                            value={this.state.value}
                                            placeholder="Source path search..."
                                            onChange={this.handleChange}
                                        />
                                        <InputGroup.Button>
                                            <Button type="submit">Search</Button>
                                        </InputGroup.Button>
                                    </InputGroup>
                                    <FormControl.Feedback />
                                </FormGroup>
                            </Form>
                        </Col>
                    </Row>
                    <BootstrapTable striped condensed data={foundMedia} >
                        <TableHeaderColumn dataField='mediaID' isKey hidden={true}>skillId</TableHeaderColumn>
                        <TableHeaderColumn dataField='datasetNum' dataSort width='8%'>Dataset</TableHeaderColumn>
                        <TableHeaderColumn dataField='mediaName' dataSort width='15%'>Media Name</TableHeaderColumn>
                        <TableHeaderColumn dataField='sourcePath' dataSort>Source Path</TableHeaderColumn>
                        <TableHeaderColumn dataField='sceneName' width='15%'>Scene</TableHeaderColumn>
                        <TableHeaderColumn dataField='lastModified' dataSort width='15%'>Last Modified</TableHeaderColumn>
                        <TableHeaderColumn dataField='sourceRepository' width='5%'>Repo</TableHeaderColumn>
                    </BootstrapTable>
                </Grid>
            </div>
        )
    }
}

MediaSearch.propTypes = {
    getSearchedMedia: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
    mediaSearchResult: state.ui.previewMedia.mediaSearchResult
});

const mapDispatchToProps = ({
    getSearchedMedia
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(MediaSearch);



// WEBPACK FOOTER //
// ./src/components/mediaSearch/MediaSearch.js